import { Component, OnInit, Input, Output, EventEmitter, forwardRef, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
 
import { HttpClient } from '@angular/common/http'; 
import {  NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {GeneralService} from "../services/general.service"
import { Router } from '@angular/router';
@Component({
  selector: 'app-recherche',
  templateUrl: './recherche.component.html',
  styleUrls: ['./recherche.component.scss'],
  providers: [
    { /* idk why or what this will do exactly.. but it works! ;) */
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RechercheComponent),
      multi: true
    }
  ]
})
export class RechercheComponent implements OnInit, AfterViewInit {
  @Input() recherche: string;
  @Input() param: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Output() ChampEnter: EventEmitter<String> = new EventEmitter<String>();
  @Output() ChampBlur: EventEmitter<String> = new EventEmitter<String>();
  parentVal: string="";
  row;
  displayedColumns = [];
  dataSource = new MatTableDataSource();
  hide = true;
  //myControl: FormControl = new FormControl();
  tbrecherche: any[];

  loading = true;
  items: any;

   exist=false;
   _param="";
  public urlApi= this.generalService.api;

   

  constructor(private router:Router,private http: HttpClient, public generalService:GeneralService ) {
    

  }

  ngOnInit() 
  {
    if(this.generalService.userConnecter == "")
    {
      this.router.navigate([""]);
    } 
  }
  ngAfterViewInit() {

   
    this.rechercheTable(this.recherche)
      .subscribe(data => {
        this.tbrecherche = data.TableRD;
        //console.log("vv  " +JSON.stringify( this.tbrecherche));
        for (let obj of this.tbrecherche) {
          //    console.log("aa " + obj);

          this.displayedColumns.push(obj["TableRD_Champs"])
        }
        //  console.log("rr " + this.displayedColumns);
        this.rechercheData(this.recherche, "").subscribe(data => {
          this.items = data; this.dataSource.data = data;
          this.exist=true;
          
        });
      });

  }

  keyenter(newHero: string) {
    if (newHero) {
       
    }
  }
  keyblur(newHero: string) {
    if (newHero) {
      this.ChampBlur.emit(newHero);
    }
  }
  onSelectionChanged(event: MatAutocompleteSelectedEvent) {
    
   if(event.option.value){
    this.ChampEnter.emit(event.option.value);
   }
  }

  focusFunction()
  {
    if(this.param){
    console.log("rr : "+this.param+ "  :  "+this._param);
    this.onModif("");
    }
  }

  rechercheData(codetb: string, codeval) {

    let v1 = "";
    let v2 = "";

    if (codeval)
      v1 = '&val=' + codeval;
    if (this.param)
      v2 = '&param=' + this.param;

    
    return this.http.get<any[]>(this.urlApi+'recherche/tbdata?tablere=' + codetb + v1 + v2);

  }

  rechercheTable(code: string) {

    return this.http.get<any>(this.urlApi+'recherche/TbRecherche?param=' + code);
  }

   
  onModif(event) {

    // console.log('cc::'+ event);
   
    this.rechercheData(this.recherche, event).subscribe(data => {
      this.items = data; this.dataSource.data = data;
      // console.log('**'+event+"**");
     if(data.length>0) this.exist=true; else  this.exist=false;
      
    });
    this._onChange(event);




  }
  
  private _onChange = (_: any) => {

   

  };
  // call if input was "touched" .. !
  private _onTouched = () => { };

  // incoming change..
  public writeValue(val: any) {
    if (val) {
      this.parentVal = val;
    }
  }
  setTextInput(cat)
  {
    if(cat)
    {
      this.row = cat;
      return cat.Art_Des
    }
  }
  public registerOnChange(fn: (_: any) => void): void { this._onChange = fn; }
  public registerOnTouched(fn: () => void): void { this._onTouched = fn; }

}
